import { motion } from "framer-motion";
import { usePrefersReducedMotion } from "@/hooks/useReducedMotion";

// Scroll-reveal wrapper. Falls back to a simple fade when reduced motion is on.
export const Reveal = ({
  children,
  className = "",
  delay = 0,
  y = 28,
  once = true,
  amount = 0.3,
  as = "div",
  ...rest
}) => {
  const reduced = usePrefersReducedMotion();
  const MotionTag = motion[as] || motion.div;

  const variants = reduced
    ? { hidden: { opacity: 0 }, show: { opacity: 1 } }
    : { hidden: { opacity: 0, y }, show: { opacity: 1, y: 0 } };

  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount }}
      variants={variants}
      transition={{
        duration: reduced ? 0.4 : 0.9,
        ease: [0.16, 1, 0.3, 1],
        delay: reduced ? 0 : delay,
      }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
